export const TestIds = {
  animatedSvg: 'animated-svg',
  animateTagForward: 'animate-tag-forward',
  animateTagBackward: 'animate-tag-backward',
  fallbackPath: 'fallback-path',
};
